import { isObject, ISODateType, TypeGuard } from '@principle-theorem/shared';
import { isNumber, isString } from 'lodash';
import { AccInvoicePaymentStatus } from './invoice/acc-invoice-enums';

export interface IAccTransactionExtendedData {
  paymentDate?: ISODateType;
  paymentReference?: string;
  paymentStatus?: AccInvoicePaymentStatus;
  awardedAmount?: number;
}

export function isAccTransactionExtendedData(
  data: unknown
): data is IAccTransactionExtendedData {
  return (
    isObject(data) &&
    TypeGuard.interface<IAccTransactionExtendedData>({
      paymentDate: TypeGuard.undefinedOr(isString),
      paymentReference: TypeGuard.undefinedOr(isString),
      paymentStatus: TypeGuard.undefinedOr(
        TypeGuard.enumValue(AccInvoicePaymentStatus)
      ),
      awardedAmount: TypeGuard.undefinedOr(isNumber),
    })(data)
  );
}
